"use client";

import React, { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";
import { ColletteCarousel } from "@collette-travel/collette-common-controls";
import TourCardCarouselSkeleton from "@/components/skeletons/tour-card-carousel-skeleton";
import { Tour } from "@/types/dto/tours/tour";
import TourCard from "./tour-card";

interface TourCarouselProps {
  tours: Tour[];
  testId: string;
  showRating?: boolean;
  openRequestAQuote?: (tour: Tour) => void;
}

const TourCardCarousel: React.FC<TourCarouselProps> = ({
  tours,
  testId,
  showRating,
  openRequestAQuote
}) => {
  const isLg = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // Delay slightly to ensure useMediaQuery has the correct value post-hydration
    const timer = setTimeout(() => setIsHydrated(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const count = tours.length;
  // On desktop with 3 or fewer cards: hide arrows and center
  const shouldHideArrows = isLg && count <= 3;

  let arrowPosition: "none" | "top-right" | "bottom";
  if (shouldHideArrows) {
    arrowPosition = "none";
  } else if (isLg) {
    arrowPosition = "top-right";
  } else {
    arrowPosition = "bottom";
  }

  return (
    <>
      {!isHydrated && <TourCardCarouselSkeleton />}
      {isHydrated && (
        <ColletteCarousel
          testId={testId}
          variant="multi-card"
          arrowPosition={arrowPosition}
          slidesToScroll="auto"
          carouselTrackSx={shouldHideArrows ? {justifyContent: "center"} : {}}
        >
          {tours.map((tour, index) => (
            <TourCard
              tour={tour}
              key={tour.id || tour.neoId || `tour-${index}`}
              carouselPosition={index + 1}
              showRating={showRating}
              openRequestAQuote={openRequestAQuote}
            />
          ))}
        </ColletteCarousel>
      )}
    </>
  );
};

export default TourCardCarousel;
